import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Button, Col} from "reactstrap";
import get from 'lodash/get';
import {Redirect} from "react-router-dom";
import {useTranslation} from "react-i18next";

import {createAvitoBot} from "../../../thunks/Connect";
import {getQueryParams} from "../../../Components/utils";
import {clearErrors} from "../../../actions/Connect";


const AvitoBot = (
    {
        activeShop,
        isSendingRequest,
        errors,
        createAvitoBot,
        clearErrors,
    }
) => {
    const {t, i18n} = useTranslation();

    const [redirectTo, setRedirectTo] = useState(undefined);

    const dashboardUrl = `/${activeShop.id}/dashboard`;

    // ComponentDidMount
    useEffect(() => {
        clearErrors();

        const params = getQueryParams();
        createAvitoBot(
            activeShop.id,
            params.code,
            (result) => setRedirectTo(dashboardUrl),
        );
    }, []);

    if (redirectTo) {
        return <Redirect to={redirectTo}/>
    }

    return <div className="d-flex justify-content-center align-items-center">
        <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100 mx-auto">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="app-header__logo w-100 justify-content-center">
                            <div className="logo-src"/>
                        </div>

                        {
                            errors && <div className="p-4 text-center">
                                <h6>🎃 {t('connect_bot.common.error', 'Error')}: {get(errors, 'common')}</h6>
                                <Button color='primary'
                                        outline
                                        className='mt-2'
                                        disabled={isSendingRequest}
                                        onClick={() => window.location.reload()}
                                >
                                    {t('connect_bot.common.try_again', 'Try again')}
                                </Button>
                            </div>
                        }
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <a href="#" className="btn-lg btn btn-link">
                            {t('connect_bot.common.back', 'Back')}
                        </a>
                    </div>
                </div>
            </div>
        </Col>
    </div>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    isSendingRequest: state.Connect.isSendingRequest,
    errors: state.Connect.errors,
});

const mapDispatchToProps = dispatch => ({
    createAvitoBot: (shop_id, avito_code, callback) => dispatch(createAvitoBot(shop_id, avito_code, callback)),
    clearErrors: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AvitoBot);
